import axios from 'axios';

const API_URL = `${process.env.NEXT_PUBLIC_API_URL}api/v1`;

// Map pour stocker les requêtes en cours
const pendingRequests = new Map();

// Fonction pour générer une clé unique pour chaque requête
const getRequestKey = (config) => {
  const {
    method, url, params, data,
  } = config;
  return `${method}:${url}:${JSON.stringify(params || {})}:${JSON.stringify(data || {})}`;
};

const Axios = axios.create({
  baseURL: API_URL,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});

// Wrapper pour les méthodes HTTP qui gère la déduplication
const createDeduplicatedRequest = (method) => (url, ...args) => {
  const config = method === 'get' || method === 'delete'
    ? {
      method, url, params: args[0],
    }
    : {
      method, url, data: args[0], ...args[1],
    };

  const requestKey = getRequestKey(config);

  // Si requête déjà en cours, retourner la Promise existante
  if (pendingRequests.has(requestKey)) {
    return pendingRequests.get(requestKey);
  }

  // Créer une nouvelle requête et la stocker
  const promise = Axios[method](url, ...args)
    .then((response) => {
      pendingRequests.delete(requestKey);
      return response;
    })
    .catch((error) => {
      const status = error.response?.status || 'Network';
      const errorData = error.response?.data || error.message;
      // eslint-disable-next-line no-console
      console.error(`❌ Erreur ${status} sur ${method.toUpperCase()} ${url}`, errorData);
      pendingRequests.delete(requestKey);
      throw error;
    });

  pendingRequests.set(requestKey, promise);
  return promise;
};

// Exporter l'API avec déduplication automatique
const api = {
  get: createDeduplicatedRequest('get'),
  post: createDeduplicatedRequest('post'),
  put: createDeduplicatedRequest('put'),
  delete: createDeduplicatedRequest('delete'),
  patch: createDeduplicatedRequest('patch'),
};

export default api;
